import { useEffect } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { useAuth } from "../../hooks/api/auth"

interface AuthGuardProps {
  children: React.ReactNode
}

export const AuthGuard = ({ children }: AuthGuardProps) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { isLoading, isAuthenticated } = useAuth()

  useEffect(() => {
    // Don't redirect while loading
    if (isLoading) return

    const publicPaths = ['/login', '/reset-password', '/invite']
    const isPublicPath = publicPaths.some(path => 
      location.pathname === path || location.pathname.startsWith(path)
    )

    // Redirect to login if not authenticated and not on a public page
    if (!isAuthenticated && !isPublicPath) {
      navigate('/login', { state: { from: location }, replace: true })
      return
    }

    // Redirect authenticated users away from login page
    if (isAuthenticated && location.pathname === '/login') {
      const from = location.state?.from?.pathname || '/orders'
      navigate(from, { replace: true })
      return
    }
  }, [isAuthenticated, isLoading, location, navigate])

  return <>{children}</>
}